import { getSkinini } from "@services/storage/skinini";
import { $$ } from "@utils/dom";
import { DATA_ATTR } from "@constants/data-attributes";

/**
 * Update the project name display from localStorage
 * Updates all project name elements (desktop and mobile)
 */
export function updateProjectName(): void {
  const skinini = getSkinini();
  const projectName = skinini.Name || "Unnamed Skin";

  const nameElements = $$(DATA_ATTR.PROJECT_NAME);
  nameElements.forEach((el) => {
    el.textContent = projectName;
  });
}
